"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSlashedDateStrAbbr = exports.formatSlashedDateStr = exports.formatFullDateStr = void 0;
exports.formatFullDateStr = 'yyyy-MM-dd';
exports.formatSlashedDateStr = 'M/d/yy';
exports.formatSlashedDateStrAbbr = 'M/d';
// All constants are exported above as individual named exports for ESM compatibility
//# sourceMappingURL=consts.js.map